import { render, staticRenderFns } from "./CreateFile.vue?vue&type=template&id=176894b0&v-on-clickaway=cancel&"
import script from "./CreateFile.vue?vue&type=script&lang=ts&"
export * from "./CreateFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports